export enum ApplicationSteps {
    General = 0,
    Technical = 1,
    Security = 2
}
